import { Injectable } from "@angular/core";

@Injectable()
export class Util {
  public static randomInt(min: number, max: number) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
  public static minutesToHourMinutes(minutes: number): string {
    const durationHour =
      Math.floor(minutes / 60) == 0 ? "" : Math.floor(minutes / 60) + "時間";
    const durationMinutes = minutes % 60 == 0 ? "" : (minutes % 60) + "分";
    return durationHour + durationMinutes;
  }
  public static formatDateTime(date: Date): string {
    const year = date.getFullYear();
    const month = Util.zeroPadding(date.getMonth() + 1);
    const d = Util.zeroPadding(date.getDate());
    const hm =
      Util.zeroPadding(date.getHours()) +
      ":" +
      Util.zeroPadding(date.getMinutes());

    return year + "年" + month + "月" + d + "日" + hm;
  }
  public static formatDate(date: Date): string {
    const month = date.getMonth() + 1;
    const d = Util.zeroPadding(date.getDate());

    return month + "/" + d;
  }
  public static formatPostedDate(date: Date): string {
    const day = "日月火水木金土"[date.getDay()];

    const now: Date = new Date();
    const sub: number = +now - +date;

    const year = date.getFullYear();
    const month = Util.zeroPadding(date.getMonth() + 1);
    const d = Util.zeroPadding(date.getDate());
    const hm =
      Util.zeroPadding(date.getHours()) +
      ":" +
      Util.zeroPadding(date.getMinutes());

    if (date.getDate() === now.getDate()) {
      return hm;
    } else {
      if (sub < 60 * 60 * 24 * 180 * 1000) {
        return month + "/" + d + "(" + day + ") " + hm;
      } else {
        return year + "/" + month + "/" + d + " " + hm;
      }
    }
  }
  public static formatPostedTime(date: Date): string {
    return (
      Util.zeroPadding(date.getHours()) +
      ":" +
      Util.zeroPadding(date.getMinutes())
    );
  }

  public static zeroPadding(num: number): string {
    if (num < 10) {
      return "0" + num;
    } else {
      return num.toString();
    }
  }
  public static range(num: number) {
    return Array.from(Array(num).keys());
  }
}



// WEBPACK FOOTER //
// ./src/providers/util/util.ts